module.exports = __webpack_public_path__ + "cebb5cb9e6e289cf159c0082f0daa2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/zh.png
// module id = 1057
// module chunks = 0